import { useState } from "react";
import { useBackfillItem } from "../api/items.js";

interface Props {
  itemId: string;
}

// Форма ручного добавления прошлой точки истории. Snapshot создаётся с
// указанной датой и помечается в rawText как backfill.

export function BackfillForm({ itemId }: Props) {
  const [open, setOpen] = useState(false);
  // Default: вчера в 04:00 UTC.
  const yesterday = new Date(Date.now() - 24 * 3600 * 1000);
  yesterday.setUTCHours(4, 0, 0, 0);
  const [date, setDate] = useState(yesterday.toISOString().slice(0, 10));
  const [time, setTime] = useState("04:00");
  const [count, setCount] = useState("");
  const [note, setNote] = useState("");
  const backfill = useBackfillItem(itemId);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-sm text-link"
      >
        + Добавить прошлую точку
      </button>
    );
  }

  const handleSubmit = () => {
    const cnt = Number.parseInt(count, 10);
    if (!Number.isFinite(cnt) || cnt < 0) {
      alert("Укажи целое число count ≥ 0");
      return;
    }
    const iso = `${date}T${time}:00.000Z`;
    backfill.mutate(
      { takenAt: iso, count: cnt, ...(note.trim() ? { note: note.trim() } : {}) },
      {
        onSuccess: () => {
          setOpen(false);
          setCount("");
          setNote("");
        },
        onError: (err) => alert(`Ошибка: ${(err as Error).message}`),
      },
    );
  };

  return (
    <div className="space-y-2 rounded-xl bg-bg-secondary p-3">
      <div className="text-sm font-semibold">Добавить прошлую точку</div>
      <div className="grid grid-cols-2 gap-2">
        <label className="block">
          <div className="mb-0.5 text-[10px] uppercase tracking-wide text-hint">
            Дата (UTC)
          </div>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="w-full rounded-lg bg-bg px-2 py-1.5 text-sm outline-none"
          />
        </label>
        <label className="block">
          <div className="mb-0.5 text-[10px] uppercase tracking-wide text-hint">
            Время (UTC)
          </div>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="w-full rounded-lg bg-bg px-2 py-1.5 text-sm outline-none"
          />
        </label>
      </div>
      <label className="block">
        <div className="mb-0.5 text-[10px] uppercase tracking-wide text-hint">
          Количество (count)
        </div>
        <input
          type="text"
          inputMode="numeric"
          value={count}
          onChange={(e) => setCount(e.target.value)}
          placeholder="13565"
          className="w-full rounded-lg bg-bg px-2 py-1.5 text-sm outline-none"
        />
      </label>
      <label className="block">
        <div className="mb-0.5 text-[10px] uppercase tracking-wide text-hint">
          Заметка (опционально)
        </div>
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="откуда взято значение"
          className="w-full rounded-lg bg-bg px-2 py-1.5 text-sm outline-none"
        />
      </label>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={backfill.isPending}
          onClick={handleSubmit}
          className="flex-1 rounded-lg bg-button px-3 py-1.5 text-sm font-medium text-button-text disabled:opacity-50"
        >
          {backfill.isPending ? "..." : "Сохранить"}
        </button>
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="rounded-lg bg-bg px-3 py-1.5 text-sm"
        >
          Отмена
        </button>
      </div>
      <div className="text-[10px] text-hint">
        Snapshot создастся с указанной датой. Запись помечается «backfill» в БД,
        чтобы не путать с автоматическими данными.
      </div>
    </div>
  );
}
